export default __webpack_public_path__ + "static/media/ripples.9ef26412.svg";